import * as types from "./actionTypes";

export const initialState = {
  token: '',
  isLoading: false,
  authorizedUser: null
};

export const AuthorizationReducer = (state = initialState, action) => {
  switch(action.type) {
    case types.SET_TOKEN:
      return {
        ...state,
        token: action.value
      }
    case types.SET_USER:
      return {
        ...state,
        authorizedUser: action.value
      }
    case types.SET_LOADING:
      return {
        ...state,
        isLoading: action.value
      }
    default:
      return state;
  }
}